/**
 * KOAI Session List Component
 * 채팅 세션 목록
 */

import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  IconButton,
  Typography,
  Divider,
  Tooltip
} from '@mui/material';
import {
  Add as AddIcon,
  Chat as ChatIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export default function SessionList({ 
  sessions, 
  currentSessionId, 
  onSelect, 
  onCreate, 
  onDelete,
  loading 
}) {
  const { t } = useTranslation();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diff = now - date;
    
    if (diff < 60000) return '방금 전';
    if (diff < 3600000) return `${Math.floor(diff / 60000)}분 전`;
    if (diff < 86400000) return `${Math.floor(diff / 3600000)}시간 전`;
    if (diff < 604800000) return `${Math.floor(diff / 86400000)}일 전`;
    
    return date.toLocaleDateString('ko-KR');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* New Chat Button */}
      <Box sx={{ p: 2 }}>
        <IconButton
          color="primary"
          onClick={onCreate}
          disabled={loading}
          sx={{
            width: '100%',
            border: '1px dashed',
            borderRadius: 1,
            py: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <AddIcon sx={{ mr: 1 }} />
          <Typography variant="body2">{t('chat.newChat')}</Typography>
        </IconButton>
      </Box>
      
      <Divider />
      
      {/* Session List */}
      <List sx={{ flexGrow: 1, overflow: 'auto', px: 1 }}>
        {sessions.length === 0 ? (
          <ListItem>
            <ListItemText
              secondary={t('common.noData')}
              sx={{ textAlign: 'center' }}
            />
          </ListItem>
        ) : (
          sessions.map((session) => (
            <ListItemButton
              key={session.id}
              selected={session.id === currentSessionId}
              onClick={() => onSelect(session)}
              sx={{
                borderRadius: 1,
                mb: 0.5,
                '&.Mui-selected': {
                  bgcolor: 'action.selected'
                }
              }}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>
                <ChatIcon fontSize="small" color="action" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography
                    variant="body2"
                    noWrap
                    sx={{ maxWidth: 160 }}
                  >
                    {session.title || '새 대화'}
                  </Typography>
                }
                secondary={formatDate(session.updated_at || session.created_at)}
              />
              <Tooltip title="삭제">
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete(session.id);
                  }}
                  sx={{
                    opacity: 0.5,
                    '&:hover': { opacity: 1 }
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </ListItemButton>
          ))
        )}
      </List>
    </Box>
  );
}
